/**
 * Whether this person can use Dr Cleanstein: an active allowance above zero.
 * The engine checks the same thing (and the monthly limits) on every question;
 * this only decides whether the Ask button shows.
 */

import { useEffect, useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';

export function useAskAccess(): boolean {
  const { supabase, user } = useAuth();
  const userId = user?.id ?? null;
  const [allowed, setAllowed] = useState(false);

  useEffect(() => {
    if (!userId) { setAllowed(false); return; }
    let cancelled = false;
    supabase
      .from('ask_allowances')
      .select('active, monthly_limit_usd')
      .eq('user_id', userId)
      // One allowance per assistant since 1 Nov; the Ask button is Ted's.
      .eq('role', 'ted')
      .maybeSingle()
      .then(({ data }) => {
        if (!cancelled) setAllowed(data?.active === true && Number(data.monthly_limit_usd) > 0);
      });
    return () => { cancelled = true; };
  }, [supabase, userId]);

  return allowed;
}
